import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ to, className = '' }) => {
    const navigate = useNavigate();
    const handleClick = () => to ? navigate(to) : navigate(-1);

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors ${className}`}
        >
            <ArrowLeft className="h-5 w-5" />
        </button>
    );
};

export default BackButton;
